import { Pipe, PipeTransform } from '@angular/core';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';

@Pipe({
    name: 'docProcessingStatusIcon',
    standalone: false
})
export class DocProcessingStatusIconPipe implements PipeTransform {
    // Optional Parameters: isForceProcessed: boolean = false, caseStatusKey: string = null,  notAllowedToReprocess: boolean = false
    // isForceProcessed is used for email only, insurance case can send false here
    // caseStatusKey, notAllowedToReprocess is used for doc reprocess mute action check
    transform(
        documentProcessingStatus: string,
        documentList: any[],
        isForceProcessed: boolean = false,
        caseStatusKey: string = null,
        notAllowedToReprocess: boolean = false
    ): any {
        const processingStatus = SCConfig.DocumentProcessingStatus;
        const hasIpexAiProcessedDoc = documentList.find(x => !x.ParashiftDocumentId && x.IpexExtractionId) != null;
        let hasFailedDoc = documentList.find(x => x.ProcessingStatus === 2) != null;
        let message: string;
        let messageMailbox: string;
        let iconSrc: string;

        if (documentProcessingStatus === processingStatus.SUCCESS && (!documentList.length || !hasIpexAiProcessedDoc)) {
            message = 'APP_CASES.DOCUMENT_P_SUCCESS';
            messageMailbox = 'APP_MAILBOX.DOCUMENT_SUCCESS';
            iconSrc = 'assets/images/Document Process complete.svg';
        } else if (documentProcessingStatus === processingStatus.SUCCESS && hasIpexAiProcessedDoc) {
            message = 'APP_CASES.DOCUMENT_P_SUCCESS';
            messageMailbox = 'APP_MAILBOX.DOCUMENT_SUCCESS';
            iconSrc = 'assets/images/Document Process complete-ipex.svg';
            const hasForceProcessedDoc =
                isForceProcessed || documentList.find(x => x.ProcessedBy === 'Ipex-Ai-Force-Processed') != null;
            if (hasForceProcessedDoc) {
                iconSrc = 'assets/images/Document Process force complete-ipex.svg';
            }
        } else if (
            documentProcessingStatus === processingStatus.FAILED ||
            documentProcessingStatus === processingStatus.UPLOAD_FAILED
        ) {
            message = 'APP_CASES.DOCUMENT_P_FAILED';
            messageMailbox = 'APP_MAILBOX.DOCUMENT_FAILED';
            iconSrc = hasFailedDoc ? 'assets/images/flash-speed-icon.svg' : 'assets/images/flash-speed-icon.svg';

            if ((caseStatusKey && caseStatusKey !== SCConfig.CaseStatus.AUDIT_PHASE.Key) || notAllowedToReprocess) {
                iconSrc = 'assets/images/flash-speed-icon-muted.svg';
            }
        } else if (documentProcessingStatus === processingStatus.PROCESSING) {
            message = 'APP_CASES.DOCUMENT_P_ONGOING';
            messageMailbox = 'APP_MAILBOX.DOCUMENT_ONGOING';
            iconSrc = 'assets/images/Document Process Ongoing.svg';
        } else {
            message = '';
            iconSrc = '';
            messageMailbox = '';
        }

        return {
            message,
            iconSrc,
            messageMailbox
        };
    }
}
